import { Heading } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import {
  isVideoRentalViewingExpiration,
  isVideoLegacyViewingExpiration,
  isVideoFixedViewingExpiration,
} from "../type-guard";
import * as Styled from "./style";
import type { CustomRequired } from "~/@types/utility-types";
import type { G_FetchVideoContentQuery } from "~/lib/graphql";
import { G_VideoPpvSaleType, G_VideoContentType } from "~/lib/graphql";
import { formatDateToYMDHm } from "~/util/format-date";

let expireDescription: string;

type DeliveryInfoProps = {
  bundleData: CustomRequired<G_FetchVideoContentQuery["videoContent"]>["ppvProducts"];
};

/** 購入モーダル内で舞台かつバンドル作品が存在する場合に配信情報を表示するためのコンポーネント */
export const DeliveryInfo = memo((props: DeliveryInfoProps) => {
  const { bundleData } = props;

  return (
    <Styled.DivGridContainer>
      <Heading size="M">配信情報</Heading>

      <Styled.DivGridContainer>
        {bundleData.map((item) => {
          if (item.saleType === G_VideoPpvSaleType.Est) {
            expireDescription = "無期限";

            return (
              <div key={item.id}>
                <Styled.ParMainText>{item.episodeTitle}</Styled.ParMainText>
                <Styled.ParSubText>視聴期限：{expireDescription}</Styled.ParSubText>
              </div>
            );
          }

          if (item.contentType === G_VideoContentType.Live_2D || item.contentType === G_VideoContentType.LiveVr) {
            expireDescription = "映像配信終了(終演)時点まで";

            return (
              <div key={item.id}>
                <Styled.ParMainText>{item.episodeTitle}</Styled.ParMainText>
                <Styled.ParSubText>視聴期限：{expireDescription}</Styled.ParSubText>
              </div>
            );
          }

          if (isVideoRentalViewingExpiration(item.viewingExpiration)) {
            const { startLimitDay, expireHour } = item.viewingExpiration;

            if (item.isPreOrder) {
              expireDescription = `配信開始から${startLimitDay}日間 視聴開始から${expireHour}時間`;
            } else {
              expireDescription = `購入から${startLimitDay}日 視聴開始から${expireHour}時間`;
            }
          }

          if (isVideoLegacyViewingExpiration(item.viewingExpiration)) {
            const { expireDay } = item.viewingExpiration;

            if (item.isPreOrder) {
              expireDescription = `配信開始日から${expireDay}日間`;
            } else {
              expireDescription = `購入から${expireDay}日間`;
            }
          }

          if (isVideoFixedViewingExpiration(item.viewingExpiration)) {
            const { expiresAt } = item.viewingExpiration;

            if (item.startDeliveryAt !== undefined && item.startDeliveryAt !== null) {
              expireDescription = `${formatDateToYMDHm(item.startDeliveryAt)} - ${formatDateToYMDHm(expiresAt)}`;
            }
          }

          return (
            <div key={item.id}>
              <Styled.ParMainText>{item.episodeTitle}</Styled.ParMainText>
              <Styled.ParSubText>視聴期限：{expireDescription}</Styled.ParSubText>
            </div>
          );
        })}
      </Styled.DivGridContainer>
    </Styled.DivGridContainer>
  );
});

DeliveryInfo.displayName = "DeliveryInfo";
